import React from "react";
import './Home.css';
import Error from "../Error/Error";
import Updated from "../Messages/Updated";
import { Link, Redirect } from "react-router-dom";
import GoldenDataService from "../../services/golden.service";
import QuestionnaireDataService from "../../services/questionnaire.service";
import SignupDataService from "../../services/signup.service";
import ConnectionDataService from "../../services/connection.service";
import UploadDataService from "../../services/upload.service";
import EmailDataService from "../../services/email.service";
import Button from "react-bootstrap/Button";
import { Card, CardHeader, CardText, CardBody, Row, Col } from "reactstrap";
import Modal from 'react-bootstrap/Modal';
require("dotenv").config();

class Home extends React.Component{

  constructor(props) {
    super(props);
    const isLoggedIn = window.localStorage.getItem("authUser") ? true : false;
    let userid = 0;
    this.handleAccept = this.handleAccept.bind(this);
    this.handleReject = this.handleReject.bind(this);
    if(isLoggedIn)
    {
    userid = window.localStorage.getItem("userid");

    }
    this.state = {
      searchname: 'N/A',
      searchage: 'N/A',
      name: '',
      userid: userid,
      interestuserid: '',
      showGolden: true,
      showQuestionnaire: true,
      showUpload: true,
      mysteryimage: 'mystery.jpg',
      matches: [],
      searchquestion1 : '',
      searchquestion2 : '',
      searchquestion3 : '',
      searchanswer1 : '',
      searchanswer2 : '',
      searchanswer3 : '',
      stage: 0,
      connectionList : [],
      downloads: [],
      token: 0,
      modalShow : false,
      displayImage : 'cupid.png',
      totalCount : 0,
      redirect: null
    };
  }

  handleAccept(event) {

    event.preventDefault();

    let data ={
      question1: this.state.searchquestion1,
      question2: this.state.searchquestion2,
      question3: this.state.searchquestion3,
      answer1 : this.state.searchanswer1,
      answer2 : this.state.searchanswer2,
      answer3 : this.state.searchanswer3,
      userid: this.state.userid,
      interestuserid: this.state.interestuserid,
      status: 1

    };
    ConnectionDataService.create(data)
    .then(response => {

        //look up user
        SignupDataService.get(this.state.interestuserid)
        .then(res => {

          let body ={
            to: res.data.email,
            from: process.env.REACT_APP_COMPANY_EMAIL,
            message : "<div>There is an interest waiting for you. Please <a href='" + process.env.REACT_APP_COMPANY_DOMAIN + "#/connection'>Log in </a> and check the Connections section.</div>",
            subject : "Hoya Saxas Interest"
          }
  
          //EmailDataService.sendEmail(body);

        })


      this.setState({searchage: 'N/A'});
      this.setState({searchname: 'N/A'});
      this.setState({searchanswer1: ''});
      this.setState({searchanswer2: ''});
      this.setState({searchanswer3: ''});
      this.setState({searchquestion1: ''});
      this.setState({searchquestion2: ''});
      this.setState({searchquestion3: ''});
      this.setState({stage: 1});
      this.setState({connectionList: [] });
      this.setState({downloads: []});
      this.setState({ redirect: "/connection" });
      
    });

  }

  handleReject(event) {
  
    event.preventDefault();
    let data ={
      question1: '',
      question2: '',
      question3: '',
      answer1 : '',
      answer2 : '',
      answer3 : '',
      userid: this.state.userid,
      interestuserid: this.state.interestuserid,
      status: 4

    };
    ConnectionDataService.create(data)
    .then(response => {

      this.setState({searchage: 'N/A'});
      this.setState({searchname: 'N/A'});
      this.setState({searchanswer1: ''});
      this.setState({searchanswer2: ''});
      this.setState({searchanswer3: ''});
      this.setState({searchquestion1: ''});
      this.setState({searchquestion2: ''});
      this.setState({searchquestion3: ''});
      this.setState({stage: 2});
      this.setState({connectionList: [] });
      this.setState({downloads: []});
      this.recalculateChecks();
      
    });


  }


  reRunList(){
    ConnectionDataService.getAll(this.state.userid)
    .then(response => {
      
        response.data.forEach(val => {
          this.setState({
            connectionList: [
            ...this.state.connectionList,
            val.interestuserid
            ]
          }); 
        });

     
       
    });
  }

  handleShow = (name) => {
    this.setState({modalShow: true});
    this.setState({displayImage: name});
  }

  handleClose = () => {
    this.setState({modalShow: false});
  }


  recalculateChecks(){

      //Give user the count of searchable users
      this.setState({totalCount:0});
      let matchCounter = 0
      SignupDataService.get(this.state.userid)
          .then(response => {
            if(response.data != '')
            {
      this.reRunList();
      SignupDataService.getAll().then(response2 => {
  
        const test = response2.data.map(
          
         person => 
         
         {
           if(response.data.gender == person.preference && response.data.preference == person.gender && response.data.id != person.id && person.golden != false && person.questionnaire != false && person.upload != false && person.active != false && person.role != 1)
           {
  
            let found = false;
  
            this.state.connectionList.map(result => {
            
                if(parseInt(result) == parseInt(person.id))
                {
                 found = true;
                }
            });
  
            if(!found)
            {
            matchCounter = matchCounter + 1;
            this.setState({totalCount: matchCounter});
            }
       
            
           }
  
          }
        )
      });
     
  
    }
  });


  SignupDataService.get(this.state.userid)
  .then(response => {
    if(response.data != '')
    {
    this.setState({token: response.data.token});
    }
  });

  }


   componentDidMount() {

    //Give user the count of searchable users
    
    let matchCounter = 0
    SignupDataService.get(this.state.userid)
        .then(response => {
          if(response.data != '')
          {
    this.reRunList();
    SignupDataService.getAll().then(response2 => {

      const test = response2.data.map(
        
       person => 
       
       {
         if(response.data.gender == person.preference && response.data.preference == person.gender && response.data.id != person.id && person.golden != false && person.questionnaire != false && person.upload != false && person.active != false && person.role != 1)
         {

          let found = false;

          this.state.connectionList.map(result => {
          
              if(parseInt(result) == parseInt(person.id))
              {
               found = true;
              }
          });

          if(!found)
          {
          matchCounter = matchCounter + 1;
          this.setState({totalCount: matchCounter});
          }
     
          
         }

        }
      )
    });
   

  }
});
    
    

    ConnectionDataService.getAll(this.state.userid)
    .then(response => {
      
        response.data.forEach(val => {
          this.setState({
            connectionList: [
            ...this.state.connectionList,
            val.interestuserid
            ]
          }); 
        });

     
       
    });


//get all photos by user id

UploadDataService.download(parseInt(this.state.userid))
.then(response => {
  if(response.data != '')
  {

    this.setState({showUpload: false});
}

})
.catch(e => {
  console.log(e);
});

//get golden questions by user id
GoldenDataService.get(parseInt(this.state.userid))
.then(response => {
  if(response.data != '')
  {

    this.setState({showGolden: false});
}

})
.catch(e => {
  console.log(e);
});

  //get questionnaires by user id
  QuestionnaireDataService.get(this.state.userid)
  .then(response => {
    if(response.data != '')
    {
   
      this.setState({showQuestionnaire: false});
    }

  });


  SignupDataService.get(this.state.userid)
  .then(response => {
    if(response.data != '')
    {
    this.setState({token: response.data.token});
    }
  });



  }


  onChangeValueAnswer1 = (event) => {
   
    this.setState({searchanswer1: event.target.value})
  }

  onChangeValueAnswer2 = (event) => {

    this.setState({searchanswer2: event.target.value})
  }

  onChangeValueAnswer3 = (event) => {

    this.setState({searchanswer3: event.target.value})
  }

  validateButton = (event) => {

    return this.state.searchanswer1.length > 0  && this.state.searchanswer2.length > 0   && this.state.searchanswer3.length > 0  
  }

   onSearchClick = async (event) => {
    event.preventDefault();

    if(parseInt(this.state.token) <= 0)
    {
      this.setState({stage: 4});
      return;
    }
    this.setState({mysteryimage: 'spinner.gif'});
    this.setState({matches: []});
    setTimeout(
      () => {
        let tokenCount = parseInt(this.state.token) - 2;
        this.setState({totalCount: this.state.totalCount - 1});
        //update the token count for the user
        let data ={
          token: tokenCount,
          userid: this.state.userid
        }

        SignupDataService.update(this.state.userid, data)
        .then(response => {
            if(response.data.message == 1)
            {
              this.setState({token: tokenCount});
            }
        });

        SignupDataService.get(this.state.userid)
        .then(response => {
          if(response.data != '')
          {
            //Next find the users questionnair choices
            //Match it with other users, sort by order and pick the top match
            QuestionnaireDataService.get(this.state.userid)
            .then(response1 => {

                if(response1.data != '')
                {
                    
                    //Get all the profiles and only find the match profile types  
                    SignupDataService.getAll().then(response2 => {

                     const test = response2.data.map(
                       
                      person => 
                      
                      {
                        if(response.data.gender == person.preference && response.data.preference == person.gender && response.data.id != person.id && person.golden != false && person.questionnaire != false && person.active != false && person.upload != false && person.role != 1)
                        {
                          QuestionnaireDataService.get(person.id)
                          .then(response3 => {

                            if(response3.data != '')
                            {
                              let score = 0
                              for(var i = 0; i <10; i++)
                              {
                                //search algorithm
                                    if(response3.data["questionnaire_" + i] == response1.data["questionnaire_" + i])
                                      {
                                        score = score + 3
                                      }

                                      if(response1.data["questionnaire_" + i]  == 1)
                                      {
                                        if(response3.data["questionnaire_" + i]== 2)
                                        {
                                          score = score - 3;
                                        }

                                        if(response3.data["questionnaire_" + i] == 3)
                                        {
                                          score = score - 2;
                                        }

                                      }

                                      if(response1.data["questionnaire_" + i]  == 2)
                                      {
                                        if(response3.data["questionnaire_" + i] == 1)
                                        {
                                          score = score - 3;
                                        }
                                        if(response3.data["questionnaire_" + i] == 3)
                                        {
                                          score = score - 2;
                                        }

                                      }
                                      if(response1.data["questionnaire_" + i]  == 3)
                                      {

                                        if(response3.data["questionnaire_" + i] != 3)
                                        {
                                          score = score - 2;
                                        }


                                      }



                              }

                              let found = false;

                              this.state.connectionList.map(result => {
                              
                                  if(parseInt(result) == parseInt(response3.data.userid))
                                  {
                                    found = true;
                                  }
                              });
                       
                           
                                if(!found) 
                                {
                                let data = {

                                    id: response3.data.userid,
                                    score: score

                                };

                             this.setState({
                             matches: [
                               ...this.state.matches,
                               data
                                ]
                                 });    

                            }


                              }

                              if(this.state.matches.length > 0)
                              {

                                  //sort the array by weight/score
                                  //pull data for the match from the profile table
                                  //pull data for the match from the image table
                                  //pull data for the match from the golden table
                                  //display it to the user only if there isn't a connection
                                  //let them either accept or reject the user
                                  

                                  this.setState({matches: [...this.state.matches.sort((a, b) => (a.score < b.score) ? 1 : -1)]})
                                 

                                  SignupDataService.get(this.state.matches[0].id).then(response5 => {
                                    this.setState({searchname: response5.data.name});
                                    this.setState({searchage: response5.data.age});
                                  });

                                  GoldenDataService.get(this.state.matches[0].id).then(response6 => {
                                    this.setState({searchquestion1: response6.data.golden1});
                                    this.setState({searchquestion2: response6.data.golden2});
                                    this.setState({searchquestion3: response6.data.golden3});
                                    this.setState({interestuserid: this.state.matches[0].id});

                                  });

                                  let arrayList = [];
                                  UploadDataService.download(parseInt(this.state.matches[0].id))
                                .then(response => {
                                if(response.data != '')
                                        {

                                          response.data.map(val  => {

                                            let data = {
                                              id: val.id,
                                              fileLink: val.fileLink,
                                              userid: val.userid,
                                              filename: val.filename
                                
                                            }
                                
                                            arrayList.push(data);

                                        this.setState({
                                          downloads: [
                                             arrayList
                                             ]
                                            });
                                    })
                                  }
                                  })
                                .catch(e => {
                                  console.log(e);
                                    });




                              }

                          })
                   

                        }
         
                      }

                     );



 
                    }).catch(e => {
                      console.log(e);
                          });


                }
                else
                {


                }

            }).catch(e => {
          console.log(e);
              });

            
          }
          else
          {
            //display unable to updated component
            //this.setState({stage: 2});
          }
        
        })
        .catch(e => {
          console.log(e);
        });
            
       
        this.setState({ mysteryimage: 'mystery.jpg' })}, 
      2000
    );

  }

  
  render(){
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />
    }
  return (
    <div className="container">

       <Row>
<Modal show={this.state.modalShow} onHide={this.handleClose}>
  <Modal.Header closeButton>
  <Button variant="secondary" onClick={this.handleClose}>
      Close
    </Button>
  </Modal.Header>
  <Modal.Body><img width="400" src={this.state.displayImage} /></Modal.Body>
  <Modal.Footer>
   
  </Modal.Footer>
</Modal>
</Row>
      <div className="row">
      {this.state.stage == 3 ? <Error Message={'System error. Please contact help desk.'}/> : ''}
      
      {this.state.showUpload || this.state.showQuestionnaire || this.state.showGolden ?
      <div className="mystery">
        We are here to provide you with the best matches based on our love algorithm.
        To begin, Please complete the following steps:
        <div>
          <ul className="div-align">
        <li  style={{visibility: this.state.showQuestionnaire ? 'visible' : 'hidden' }}> Compatibility <Link to="/questionnaire">questionnaire</Link></li>
        <li style={{visibility: this.state.showGolden ? 'visible' : 'hidden' }}>Golden  <Link to="/golden">questions</Link></li>
        <li style={{visibility: this.state.showUpload ? 'visible' : 'hidden' }}>Upload  <Link to="/upload">images</Link> </li>
       
        </ul>
        </div>
    
      </div> : ''}
      </div>

        {this.state.showQuestionnaire != true && this.state.showGolden != true && this.state.showUpload != true ? 
        <div className="home-search col-md-12">   
        <span className="text-font">There are currently <span className="token-color">{this.state.totalCount}</span> Matches available. </span><br/>
        <span className="text-font">You currently have <span className="token-color">{this.state.token}</span> tokens. </span>
      {this.state.stage == 1 ? <Updated Color={'accept-color'}  Message={'You have accepted your potential match. Check back your on Connections menu.'}/> : ''}
      {this.state.stage == 2 ? <Updated Color={'reject-color'}  Message={'You have rejected your potential match.'}/> : ''}
      {this.state.stage == 4 ? <Updated Color={'reject-color'}  Message={'You have no more tokens left. Please purchase them through the settings Menu.'}/> : ''}
      {parseInt(this.state.token) > 0 && parseInt(this.state.totalCount) > 0? 
      <div>Click the <button width="40px" type="button" onClick={this.onSearchClick} style={{visibility: parseInt(this.state.token) > 0 && parseInt(this.state.totalCount) > 0 ? 'visible' : 'hidden' }} ><img  style={{visibility: parseInt(this.state.token) > 0  && parseInt(this.state.totalCount) > 0  ? 'visible' : 'hidden' }} width="40px" src={'search.png'} alt="search" /></button> icon and let our Love algorithm do the rest.</div>
      : ''}
      <div className="row col-md-12">

        {this.state.downloads.length > 0 ? 
              <div className="row col-md-12">
              {this.state.downloads.map(dat => dat.map(fat => (
                      <div className="row col-md-3 panel-size">
                        <Col className="border-img" md="12">  
                    <img  onClick={() => this.handleShow(fat.fileLink)} width="75"  height="75" src={fat.fileLink} /><br/>
                    <label>{fat.filename}</label><br/>
                  </Col>
                  </div>
                 )
                 ))
               }
        
                </div>
        :
        <div className="col-md-12">
          <img className="image-transform" width="200px"  src={this.state.mysteryimage} alt="mystery image" />
        </div>
        }
    <div className="col-md-12 profile">
        <div className="col-md-12">
          Name : {this.state.searchname}
        </div>
        <div className="col-md-12">
          Age : {this.state.searchage}
        </div>
        </div>
        <br/>
        {this.state.searchquestion1 != '' ?
        <div className="row">
             <div className="row col-md-11 offset-2">
          <b>Please answer the following questions</b>
               </div>
      <div className="row col-md-12">
        <div className="row guestion-color col-md-12 universal-margin">
          <label>{this.state.searchquestion1}</label>
          <textarea value={this.state.searchanswer1} onChange={this.onChangeValueAnswer1} placeholder="140 characters only" maxLength="140" className="title" name="text-padding" cols="30" rows="3"></textarea>
        </div>
        <div className="row guestion-color col-md-12 universal-margin">
        <label>{this.state.searchquestion2}</label>
          <textarea value={this.state.searchanswer2} onChange={this.onChangeValueAnswer2} placeholder="140 characters only" maxLength="140" className="title" name="text-padding" cols="30" rows="3"></textarea>
        </div>
        <div className="row question-color col-md-12 universal-margin">
          <label>{this.state.searchquestion3}</label>
          <textarea value={this.state.searchanswer3} onChange={this.onChangeValueAnswer3} placeholder="140 characters only" maxLength="140" className="title" name="text-padding" cols="30" rows="3"></textarea>
        </div>
        <label className="col-md-6 offset-4">*All fields are required, if sending interest</label>
      </div>
      <div className="row col-md-6 offset-4">
        <div className="col-md-4">
            <Button style={{cursor:'pointer'}}  disabled={!this.validateButton()} onClick={this.handleAccept} className="btn btn-success">Send Interest</Button>
            </div>
            <div className="col-md-4">
            <Button style={{cursor:'pointer'}}  onClick={this.handleReject} className="btn btn-danger">Not Interested</Button>
            </div>
        </div></div>
        : ''}
        
      </div>
      <div>
        </div>
     
      </div>
        : '' }

      
    </div>
  );
    

  }

}

export default Home;